import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import * as L from 'leaflet';
import { LMapComponent } from './l-map.component';


@Component({
    selector: 'map-tiles-layer',
    template: ``,
})
export class TilesLayerComponent implements OnInit, OnDestroy {

    @Input() name: string;

    @Input() zIndex: string;

    @Input() urlTemplate: string;

    @Input() options: L.TileLayerOptions;

    private layer: L.TileLayer;

    constructor(private map: LMapComponent) {}

    ngOnInit() {
        const map = this.map.lMapService.getMap();

        if (!map.getPane(this.name)) {
            map.createPane(this.name).style.zIndex = this.zIndex;
        }

        this.layer = new L.TileLayer(this.urlTemplate, { ...this.options, pane: this.name });
        map.addLayer(this.layer);
    }

    ngOnDestroy() {
        const map = this.map.lMapService.getMap();
        map.removeLayer(this.layer);
    }
}
